const makeTasks = () => {
    return {};
};

export default makeTasks;
